import '/styles/main.scss'
import './nav.js'
import './carousel.js'
import './whatsapp.js'
import './video.js'
import './anim_section.js'
